import { ThemeProvider } from '@emotion/react'
import { LoadingSpinner, PAYPAL_THEME } from '@paypalcorp/pp-react'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import _get from 'lodash/get'
import PropTypes from 'prop-types'
import React, { lazy, Suspense, useEffect, useRef } from 'react'
import ShimmerLoader from './components/loaders/shimmerLoader'
import { AppContextProvider } from './contexts/app-context'
import Page from './page'
import { SERVER_DATA } from './utils/prop-type-shape'

const MppHeaderComponent = lazy(() =>
  import('./components/layout/mpp/mppHeader' /* webpackPrefetch: true */),
)

const MppFooterComponent = lazy(() =>
  import('./components/layout/mpp/mppFooter' /* webpackPrefetch: true */),
)

const App = (props) => {
  const { serverData } = props

  const spinnerRef = useRef(null)

  useEffect(() => {
    spinnerRef.current.remove()
  }, [])
  /*
    Creating an appContext object which will have pageProps and reqContextData or
    any other data in future based on the requirements, so that we can save this through
    the contextProvider for all the components to access.
    pageProps -  This will will have the data required for the page to render like components data, 
                  RC data, ELMO data, any other related data on a page level.
    reqContextData - client will not have access to the express request. so this will hold the req data
                     concolidated to the UI needs.

    The context is used to manage global data, e.g. global state, req data, theme, services, user settings, and more
    */
  const { pageProps, reqContextData } = serverData
  const { isLoggedIn } = reqContextData
  const appContextData = {
    pageProps,
    reqContextData,
  }

  // Render Logged Out MPP [Marketing-Components] Header
  const renderMppHeader = () => {
    if (!isLoggedIn) {
      const headerData = _get(serverData, 'navigation.mpp.header')
      return (
        <Suspense fallback={<ShimmerLoader />}>
          <MppHeaderComponent
            data={headerData}
            reqContextData={reqContextData}
          />
        </Suspense>
      )
    }
    return <></>
  }

  // Render Logged Out MPP [Marketing-Components] Footer
  const renderMppFooter = () => {
    if (!isLoggedIn) {
      const footerData = _get(serverData, 'navigation.mpp.footer')
      return (
        <Suspense fallback={<ShimmerLoader />}>
          <MppFooterComponent
            data={footerData}
            reqContextData={reqContextData}
          />
        </Suspense>
      )
    }
    return <></>
  }

  return (
    <>
      <ThemeProvider theme={PAYPAL_THEME}>
        <div ref={spinnerRef} className="hc-page__loader">
          <LoadingSpinner screenReaderText="loading" size="xl" />
        </div>
      </ThemeProvider>
      {renderMppHeader()}
      <WorldReadyContextProvider locale={serverData.locality.locale}>
        <AppContextProvider appContextData={appContextData}>
          <ThemeProvider theme={PAYPAL_THEME}>
            <div className="main-page-container">
              <Page {...appContextData} />
            </div>
          </ThemeProvider>
        </AppContextProvider>
      </WorldReadyContextProvider>
      {renderMppFooter()}
    </>
  )
}

App.propTypes = {
  serverData: PropTypes.shape(SERVER_DATA),
}
export default App
